import { useState } from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import type { ProxyStatusFilter, ProxyGroupFilter } from "./useProxyList";

interface ProxyListFiltersProps {
  status: ProxyStatusFilter;
  group: ProxyGroupFilter;
  onStatusChange: (status: ProxyStatusFilter) => void;
  onGroupChange: (group: ProxyGroupFilter) => void;
}

const STATUS_OPTIONS: { value: string; label: string }[] = [
  { value: "", label: "Все" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

export function ProxyListFilters(props: ProxyListFiltersProps) {
  const { status, group, onStatusChange, onGroupChange } = props;
  const [groupInput, setGroupInput] = useState(group ?? "");

  const handleStatusChange = (value: string) => {
    onStatusChange(value === "" ? undefined : (value as NonNullable<ProxyStatusFilter>));
  };

  const applyGroupFilter = () => {
    const trimmed = groupInput.trim();
    const next = trimmed === "" ? undefined : trimmed;
    if (next !== group) {
      onGroupChange(next);
    }
  };

  return (
    <Box display="flex" gap={1} alignItems="center">
      <Box flex="1 1 130px" maxWidth={180}>
        <FormControl fullWidth size="small">
          <InputLabel>Статус</InputLabel>
          <Select
            value={status ?? ""}
            label="Статус"
            onChange={(event) => handleStatusChange(event.target.value)}
          >
            {STATUS_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <Box flex="1 1 130px" maxWidth={200}>
        <TextField fullWidth
          size="small"
          label="Группа"
          helperText="Пусто — все группы"
          value={groupInput}
          onChange={(event) => setGroupInput(event.target.value)}
          onBlur={applyGroupFilter}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              applyGroupFilter();
            }
          }}
        />
      </Box>
    </Box>
  );
}
